import React from 'react';
import {
  Drawer,
  DrawerHeader,
  DrawerBody,
  Typography
} from '@one-thd/sui-atomic-components';
import { bool, func, string } from 'prop-types';
import { DRAWER_INFO } from '../constants/index';

export const InfoDrawer = ({ type, isOpen, onClose }) => {
  const drawerData = DRAWER_INFO[type];

  if (!drawerData) {
    return null;
  }

  const { info, header: drawerHeader } = drawerData;

  return (
    <Drawer open={isOpen} onClose={onClose}>
      <DrawerHeader
        title={(
          <Typography variant="h4" height="none">{drawerHeader}</Typography>
        )}
        onClose={onClose}
      />
      <DrawerBody>
        <div className="sui-mt-2">
          {info?.map(({ title, sections }, infoIndex) => {
            const isLastInfo = info?.length - 1 === infoIndex;
            const hasNoSections = sections?.length === 0;

            return (
              <div
                className={`sui-flex sui-flex-col sui-mb-3 ${isLastInfo && hasNoSections ? '!sui-mb-0' : ''}`}
                key={`info- ${title}`}
              >
                {title && (
                  <div
                    className={`sui-mb-3 ${hasNoSections ? '!sui-mb-0' : ''}`}
                  >
                    <Typography variant="h6" height="normal">
                      {title}
                    </Typography>
                  </div>
                )}
                {sections?.map((section, sectionIndex) => {
                  const { header = '', text = '', list = [] } = section;
                  const isLastSection = sections?.length - 1 === sectionIndex;
                  const sectionMargin = `sui-mb-3 ${isLastInfo && isLastSection ? '!sui-mb-0' : ''}`;

                  return (
                    <>
                      {header && (
                        <div className={sectionMargin}>
                          <Typography variant="body-base" height="normal">
                            {header}
                          </Typography>
                        </div>
                      )}
                      {text && (
                        <div className={sectionMargin}>
                          <Typography variant="body-base" height="normal">
                            {text}
                          </Typography>
                        </div>
                      )}
                      {!!list?.length && (
                        <div className={sectionMargin}>
                          <ul className="sui-list-disc sui-pl-6" role="presentation">
                            {list?.map((listItem) => {
                              return (
                                <li key={`list- ${listItem}`}>
                                  <Typography variant="body-base" height="normal">
                                    {listItem}
                                  </Typography>
                                </li>
                              );
                            })}
                          </ul>
                        </div>
                      )}
                    </>
                  );
                })}
              </div>
            );
          })}
        </div>
      </DrawerBody>
    </Drawer>
  );
};

InfoDrawer.propTypes = {
  type: string,
  isOpen: bool,
  onClose: func
};

InfoDrawer.defaultProps = {
  type: '',
  isOpen: false,
  onClose: () => {}
};